import React from 'react'
import SwitchContainer from '../../../../Components/Forms/FormWidgets/Switch'

export default function Switch() {
  return (
    <div className='page-body'>
      <SwitchContainer />
    </div>
  )
}